import * as S from './Button.styles';

export type Color = 'gradient' | 'grey' | 'green';
export type Size = 'small' | 'medium';
export type Variant = 'filled' | 'outlined';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: Color;
  size?: Size;
  variant?: Variant;
  isFullWidth?: boolean;
  isLoading?: boolean;
};

export const Button = (props: Props) => {
  const {
    color = 'gradient',
    size = 'medium',
    variant = 'filled',
    isFullWidth = false,
    isLoading = false,
    children,
    ...buttonProps
  } = props;

  return (
    <S.Root
      $color={color}
      $size={size}
      $variant={variant}
      $isFullWidth={isFullWidth}
      $isLoading={isLoading}
      {...buttonProps}
    >
      {children}
      {isLoading && <S.Loader />}
    </S.Root>
  );
};
